import history from '../../utils/history';
import api from '../../utils/api';
import { ERROR_MESSAGE } from '../constants/signUpTypes';

const errorMessage = (message) => ({ type: ERROR_MESSAGE, payload: message });

export const createNewAccount = (data) => (dispatch) => {
  api
    .post('/users', data)
    .then(() => {
      history.push('/welcome');
      dispatch(errorMessage(''));
    })
    .catch((error) => {
      dispatch(errorMessage(error.response.data.message));
    });
};
